import React, {Component} from "react";
import {Checkbox, Collapse, Divider} from "antd";
import * as R from "ramda";
import * as PropTypes from "prop-types";
import {getRecipe, ItemSmall} from "./Boilerplate/ItemSmall";
import "./CharacterRecipes.less";

const IngredientText = props => <span>{props.count > 1 && `${props.count}x `}<ItemSmall inline name={props.name}/></span>;

IngredientText.propTypes = {
  count: PropTypes.any,
  name: PropTypes.any
};

class RecipeIngredient extends Component {
  state = {
    expanded: false,
  };

  handleClick = path => event => {
    const crafting = JSON.parse(localStorage.getItem('crafting') || "{}");
    const setValues = value => obj => typeof(obj) !== 'object' ? value : R.map(setValues(value), obj);
    const originalValue = R.view(R.lensPath(path), crafting);
    const newValue = JSON.stringify(R.set(R.lensPath(path), setValues(event.target.checked)(originalValue), crafting));
    localStorage.setItem('crafting', newValue);
  };

  evaluateAcquiredRecursive = (crafting, path) => {
    const value = R.view(R.lensPath(path), crafting) || false;
    if (typeof(value) === 'boolean') return value;
    if (Array.isArray(value)) {
      let result = true;
      value.forEach((val, idx) => result = result && this.evaluateAcquiredRecursive(crafting, path.concat(idx)));
      return result;
    }
    return Object.keys(value).map(key => this.evaluateAcquiredRecursive(crafting, path.concat(key))).reduce((acc, cur) => acc || cur);
  };

  render() {
    const {count, inline, name, recursive, path=[name], parentChecked=false} = this.props;
    const crafting = JSON.parse(localStorage.getItem('crafting') || "{}");
    const checked = this.evaluateAcquiredRecursive(crafting, path);
    const recipe = getRecipe(name);
    return <div
      style={{marginBottom: (!inline && '1em'), display: 'flex'}}
      onClick={() => recursive && recipe && this.setState({expanded: !this.state.expanded})}
    >
      <Checkbox checked={parentChecked || checked} onChange={this.handleClick(path)}/>
      {recursive && recipe ?
      <Collapse bordered={false}>
        <Collapse.Panel key={name} header={<IngredientText count={count} name={name}/>}>
          <div>{Object.values(recipe).map((ingredient, ingredient_index) => {
            const options = Object.keys(ingredient);
            return options.length > 1 ?
              <div className={'interchangeable'}>{options.map((name, option_index) =>
                <RecipeIngredient count={ingredient[name]} name={name} recursive={recursive} inline path={path.concat([option_index, name])} parentChecked={parentChecked || checked}/>
              ).reduce((accumulator, current) => <React.Fragment>
                {accumulator}<Divider dashed orientation='left'>OR</Divider>{current}</React.Fragment>)
              }</div> :
              <RecipeIngredient count={ingredient[options[0]]} name={options[0]} recursive={recursive} path={path.concat([ingredient_index, options[0]])} parentChecked={parentChecked || checked}/>;
          })}</div>
        </Collapse.Panel>
      </Collapse> :
      <IngredientText count={count} name={name}/>}
    </div>;
  }
}

RecipeIngredient.propTypes = {
  name: PropTypes.string,
  inline: PropTypes.bool,
  recursive: PropTypes.bool,
  path: PropTypes.array,
  parentChecked: PropTypes.bool,
};

export class CharacterRecipes extends Component {
  render() {
    return <>
      <Divider style={{marginTop: 0}}>Crafting</Divider>
      <div className="content">
        {Object.values(this.props.equipped).filter(i => i).map(i => <RecipeIngredient name={i} recursive/>)}
      </div>
    </>;
  }
}

CharacterRecipes.propTypes = {
  equipped: PropTypes.object.isRequired,
};
